import dynamic from 'next/dynamic';

const DynamicComponentWithNoSSR = dynamic(
  () => import('../../components/insights/index'),
  { ssr: false }
);

const Index = () => {
  return <DynamicComponentWithNoSSR></DynamicComponentWithNoSSR>;
};

export default Index;
